import { type QueryClient } from 'src/core/api/client';
import { useQuery } from 'src/core/api/hooks/useQuery';

type Params = {
  isEnabled?: boolean;
};

type KycRemediationResult = {
  onboardingUrl: string;
  kycCaseType: 'director_ubo_remediation';
  status: 'draft' | 'open' | 'approved' | 'rejected';
};

type KycRemediationError = {
  reason: string;
};

export const useFetchKycRemediation = ({ isEnabled = true }: Params = {}) => {
  return useQuery<KycRemediationResult, KycRemediationError>({
    key: ['kyc-remediation'],
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: `/onboarding/kyc/sfs/eea/kyc-remediation`,
    },
    isEnabled,
    options: {
      staleTime: 2 * 60 * 1000,
      cacheTime: 2 * 60 * 1000,
    },
  });
};

export const invalidateKycRemediationQuery = (
  queryClient: QueryClient,
): void => {
  queryClient.invalidateQueries(['kyc-remediation']);
};
